import React, { Component } from 'react';
import Terms from './termsofuse';
import TermsPerm from './termsofuseperm';
import TermsArchive from './termsofusearchive';

export class TermsOfUse extends Component {
  constructor() {
    super();
  }

  render() {
    return (
      <div>
        <Terms />
      </div>
    );
  }
}

export class TermsOfUsePerm extends Component {
  constructor() {
    super();
  }

  render() {
    return (
      <div>
        <TermsPerm />
      </div>
    );
  }
}

export class TermsOfUseArchive extends Component {
  constructor() {
    super();
  }

  render() {
    const districtName = this.props.match.params.districtName;
    return (
      <div>
        <TermsArchive districtName={districtName} />
      </div>
    );
  }
}

export default TermsOfUse;
